const openModal = (modal, showOverflow = false) => {
  if (!modal) return;
  const foundModal =
    typeof modal === 'string' ? document.querySelector(modal) : modal;
  if (!foundModal) return;

  foundModal.style.display = 'block';
  if (!showOverflow) {
    document.querySelector('html').style.overflow = 'hidden';
    document.querySelector('html').classList.add('modal--opened');
  }
  setTimeout(() => {
    window.requestAnimationFrame(() => {
      foundModal.classList.add('open');
      foundModal.display = '';
      if (foundModal.getAttribute('tabindex')) foundModal.focus();
    });
  }, 100);
};

const closeModal = (modal) => {
  if (!modal) return;
  const foundModal =
    typeof modal === 'string' ? document.querySelector(modal) : modal;
  if (!foundModal) return;

  const transitionDuration =
    parseFloat(
      getComputedStyle(foundModal).transitionDuration.replace('s', ''),
    ) * 1000;
  foundModal.style.display = 'block';
  window.requestAnimationFrame(() => {
    foundModal.classList.remove('open');
    setTimeout(() => {
      foundModal.style.display = '';
      document.querySelector('html').style.overflow = '';
      document.querySelector('html').classList.remove('modal--opened');
    }, transitionDuration);
  });
};

const initModals = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  document.querySelectorAll('.modal').forEach((modal) => {
    modal
      .querySelectorAll('.modal__backdrop , .modal__close')
      .forEach((closer) =>
        closer.addEventListener('click', () => closeModal(modal)),
      );
    if (modal.getAttribute('tabindex'))
      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeModal(modal);
      });
    if (modal.id)
      rootEl.querySelectorAll(`a[href*="${modal.id}"]`).forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();

          let showOverflow = false;

          if (e.target.dataset.attribute == 'geolocation') {
            modal.classList.add(e.target.dataset.target);
          }

          if (e.target.dataset.attribute == 'filters') {
            showOverflow = true;
          }

          if (!modal.classList.contains('open')) openModal(modal, showOverflow);
        }),
      );
  });
};

export { initModals, openModal, closeModal };

// Expose openModal globally for use in Liquid snippets (e.g., Swym integration)
if (!window.dAgency) window.dAgency = {};
window.dAgency.openModal = openModal;
